var path = 'msi/subscriptions/reactivate/reactivate-subscription.html';
var html = "<button type=\"button\" ng-disabled=\"$ctrl.subscription.product.discontinued\" ng-click=\"$ctrl.reactivate()\">{{'SUBSCRIPTION_REACTIVATE_BUTTON' | translate}}</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;